<div class="signup-page">
    <div class="signup-hero" style="background-image: url('assets/img/hero/console.png')">
        <div class="signup-overlay">
            <div class="signup-left">
                <h1>Sign In/Sign Up</h1>
                <p>Welcome To Yogamez Hub</p>
            </div>
            <div class="signup-card">
                <h2>Sign Up</h2>
                <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
                    <label>Username</label>
                    <span *ngIf="signupForm.get('username')?.invalid && signupForm.get('username')?.touched"
                          class="error-text">
                        Username is required
                    </span>
                    <div class="input__item">
                        <span class="fa fa-user"></span>
                        <input type="text" placeholder="User123" formControlName="username">
                    </div>

                    <label>Phone Number</label>
                    <span *ngIf="signupForm.get('phoneNumber')?.errors?.['required'] && signupForm.get('phoneNumber')?.touched"
                          class="error-text">
                        Phone Number is required
                    </span>
                    <span *ngIf="signupForm.get('phoneNumber')?.errors?.['isEconetSubscriber'] && signupForm.get('phoneNumber')?.touched && signupForm.get('phoneNumber')?.value!=''"
                          class="error-text">
                        Invalid Econet number. It must start with 077, 078, or 079 and have 10 digits.
                    </span>
                    <div class="input__item">
                        <span class="fa fa-phone"></span>
                        <input type="text" placeholder="0791234567" formControlName="phoneNumber" maxlength="10">
                    </div>

                    <label>Password</label>
                    <span *ngIf="signupForm.get('password')?.hasError('required') && signupForm.get('password')?.touched"
                          class="error-text">
                        Password is required
                    </span>
                    <span *ngIf="signupForm.get('password')?.hasError('minlength') && signupForm.get('password')?.touched"
                          class="error-text">
                        Password must be at least 6 characters long
                    </span>
                    <div class="input__item">
                        <span class="fa fa-lock"></span>
                        <input [type]="isPasswordVisible ? 'text' : 'password'" placeholder="Enter Password"
                               formControlName="password">
                        <button class="toggle-password-btn" type="button" (click)="togglePasswordVisibility()">
                            <i *ngIf="isPasswordVisible" class="fa fa-eye-slash"></i>
                            <i *ngIf="!isPasswordVisible" class="fa fa-eye"></i>
                        </button>
                    </div>

                    <label>Referral Code</label>
                    <div class="input__item">
                        <span class="fa fa-hashtag"></span>
                        <input type="text" placeholder="ReferralCode" formControlName="referralCode">
                    </div>

                    <p class="terms-text">
                        Accept the Terms and Conditions
                        <a href="#" data-toggle="modal" data-target="#staticBackdrop">here</a>
                        to proceed
                    </p>
                    <span *ngIf="!hasAcceptedTerms && submitClicked" class="error-text">
                        Accept Terms To Proceed *
                    </span>

                    <div class="signup-actions">
                        <button type="submit" class="site-btn">Sign Up</button>
                        <p>Already have an account? <a (click)="routeToPage('/login')">Sign In!</a></p>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="modal  fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1"
         aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-logo">
                        <img src="assets/img/logo/yogamez-hub-dark-480.png" alt="YoGamez HUB" width="205" height="79">
                    </div>
                    <div class="title-modal">
                        <h5 class="modal-title font-weight-bold" id="staticBackdropLabel">YoGames Hub Terms and
                            Conditions</h5>
                    </div>


                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <app-terms-conditions (scrolledToBottom)="onScrolledToBottom($event)"></app-terms-conditions>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="acceptTerms()" [disabled]="isButtonDisabled">Accept</button>
                </div>
            </div>
        </div>
    </div>
</div>
